module.exports = {"id":"dp5_3l1q1","text":"Identifying creative solutions using digital technologies","instructions":"Digital technologies can fully replace human creativity in problem solving?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.3","questionType":"PickOne","random":false,"options":[{"id":"dp5_3l1q1-a1","text":"False","score":1.8},{"id":"dp5_3l1q1-a2","text":"Not sure","score":0},{"id":"dp5_3l1q1-a3","text":"True","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.3/l1q1.json
// module id = 1324
// module chunks = 41